import React from "react";
import { Navigate } from "react-router-dom";

/**
 * OpsChat is now the base of the unified ladder on the home page (#pricing).
 * This URL redirects for bookmarks and external links.
 */
export default function OpsChatPage() {
  return <Navigate to="/#pricing" replace />;
}
